






























































import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';

import { Tank } from '@/api';
import { FuelAllocationService } from '@/modules/fuel-allocations/fuel-allocation-service';
import { AllocationSummary } from '@/modules/fuel-allocations/models/allocation-summary';

@Component({})
export default class FuelAllocationsTab extends Vue {
	@Prop({ required: true, type: Object })
	private tank!: Tank;

	@Prop({ required: true, type: Boolean })
	public isPremium!: boolean;

	public allocationSummary: AllocationSummary | null = null;
	public loading: boolean = true;
	public totalFuelPurchased: number = 0;
	public ineligibleUse: number = 0;

	public get startDate(): string {
		return moment.unix(this.startTime).format('DD MMMM YYYY');
	}

	public get endDate(): string {
		return moment.unix(this.finishTime).format('DD MMMM YYYY');
	}

	public get selectedQuarter(): string {
		return `Quarter ${this.dateFromTs(this.startTime).quarter()}`;
	}

	public allocationSummaryItems(allocationSummary: AllocationSummary) {
		const { openingBalance, closingBalance, unallocatedTotal, allocatedTotal } = allocationSummary;
		return [
			{
				opening_balance: openingBalance,
				closing_balance: closingBalance,
				unallocated_total: unallocatedTotal,
				allocated_total: allocatedTotal,
			},
		];
	}

	private startTime: number = this.dateToTs(this.currentQuarter.startOf('quarter'));
	private finishTime: number = this.dateToTs(this.currentQuarter.endOf('quarter'));
	private allocationService = new FuelAllocationService(this.tank);

	// Quarter of today's date (not selected date)
	private get currentQuarter(): moment.Moment {
		return moment().quarter(moment().quarter());
	}

	public async created(): Promise<void> {
		this.allocationService.summary.subscribe(
			(summary: AllocationSummary | null) => (this.allocationSummary = summary),
		);
		await this.loadEvents();
		this.loading = false;
	}

	public unmounted(): void {
		this.allocationService.destroy();
		this.allocationService.summary.unsubscribe();
	}

	public previousQuarter(): void {
		this.startTime = this.shiftQuarterTs(this.startTime, 'back', true);
		this.finishTime = this.shiftQuarterTs(this.finishTime, 'back');
		this.loadEvents();
	}

	public nextQuarter(): void {
		this.startTime = this.shiftQuarterTs(this.startTime, 'forward', true);
		this.finishTime = this.shiftQuarterTs(this.finishTime, 'forward');
		this.loadEvents();
	}

	private async loadEvents(): Promise<void> {
		await this.allocationService.loadEvents({
			startTime: this.startTime - 1, // Include the tank balance from previous midnight (our starting balance)
			finishTime: this.finishTime,
		});
	}

	private shiftQuarterTs(
		timestamp: number,
		direction: 'forward' | 'back',
		startOfQuarter?: boolean,
	): number {
		let quarterDate = this.dateFromTs(timestamp);
		if (direction === 'forward') {
			quarterDate = quarterDate.add(1, 'quarter');
		} else {
			quarterDate = quarterDate.subtract(1, 'quarter');
		}
		if (startOfQuarter) {
			quarterDate = quarterDate.startOf('quarter').startOf('day');
		} else {
			quarterDate = quarterDate.endOf('quarter').endOf('day');
		}
		return this.dateToTs(quarterDate);
	}

	private dateFromTs(timestamp: number): moment.Moment {
		return moment.unix(timestamp);
	}

	private dateToTs(date: moment.Moment): number {
		return Math.floor(date.valueOf() / 1000);
	}
}
